module.exports = __webpack_public_path__ + "img/panelView_strong_Bg_89_1_3.02b94f9b.png";